<template>
	<div class="draw-item" :class="{'z-dis': disabled || handleState}" @mousedown="e => handleState ? '' : moveStart(e)">
		<div ref="content" class="content" :class="{'z-move': moveState}" :style="{'left': `${moveSeat.x}px`, 'top': `${moveSeat.y}px`}">
			<slot></slot>
			<div v-if="handleState" ref="handle" class="handle" :style="handleStyle" @mousedown.stop="moveStart">
				<slot name="handle"></slot>
			</div>
			<div v-show="moveState" class="shade"></div>
		</div>
		<div v-show="moveState" class="place" :style="placeStyle"></div>
	</div>
</template>

<script>
	function getStyle(obj, attr) {
		if (obj.currentStyle) {
			return obj.currentStyle[attr];
		} else {
			return getComputedStyle(obj, false)[attr];
		}
	}
	
	function getPosition(elem){
		var elemTop = elem.offsetTop;
		var elemLeft = elem.offsetLeft;
		elem = elem.offsetParent;
		while (elem != null) {
			elemTop += elem.offsetTop - elem.scrollTop;
			elemLeft += elem.offsetLeft - elem.scrollLeft;
			elem = elem.offsetParent;
		}
		return {
			top: elemTop,
			left: elemLeft
		}
	}
	
	import global from '@/assets/script/function';
	
	export default {
		name: 'cDrawItem',
		
		props: {
			index: Number,
			handleStyle: Object
		},
		
		data() {
			return {
				moveState: false,
				
				boxSeat: {
					x: 0,
					y: 0
				},
				moveSeat: {
					x: 0,
					y: 0
				},
				clientSeat: {
					x: 0,
					y: 0
				},
				
				placeStyle: {},
				handleSize: {},
				
				disabled: this.$parent.disabled
			}
		},
		
		computed: {
			handleState() {
				return this.$slots.handle;
			}
		},
		
		methods: {
			moveStart(e) {
				if (this.disabled) return;
				
				['margin-top', 'margin-bottom', 'margin-left', 'margin-right'].forEach(item => {
					this.$set(this.placeStyle, item, getStyle(this.$refs.content.children[0], item));
				});
				this.$set(this.placeStyle, 'width', parseInt(getStyle(this.$refs.content, 'width')) - parseInt(this.placeStyle['margin-left']) - parseInt(this.placeStyle['margin-right']) + 'px');
				this.$set(this.placeStyle, 'height', getStyle(this.$refs.content, 'height'));
				
				['width', 'height'].forEach(item => {
					this.$set(this.handleSize, item, getStyle(this.handleState ? this.$refs.handle : this.$refs.content.children[0], item));
				});
				if (this.handleState) {
					this.$set(this.handleSize, 'offsetLeft', this.$refs.handle.offsetLeft);
					this.$set(this.handleSize, 'offsetTop', this.$refs.handle.offsetTop);
				}
				
				this.moveState = true;
				this.boxSeat = {
					x: this.$parent.$el.getBoundingClientRect().x,
					y: this.$parent.$el.getBoundingClientRect().y
				}
				this.updateMoveSeat(e);
				
				document.addEventListener('mousemove', this.move);
				document.addEventListener('mouseup', this.moveEnd);
			},
			
			move(e) {
				this.updateMoveSeat(e);
				this.updateSort();
			},
			
			moveEnd() {
				this.moveState = false;
				this.moveSeat.x = 0;
				this.moveSeat.y = 0;
				
				document.removeEventListener('mousemove', this.move);
				document.removeEventListener('mouseup', this.moveEnd);
				
				this.$parent.sortEnd();
			},
			
			updateMoveSeat(e) {
				this.clientSeat.x = e.clientX - this.boxSeat.x;
				this.clientSeat.y = e.clientY - this.boxSeat.y;
				this.moveSeat.x = this.clientSeat.x - parseInt(this.placeStyle['margin-left']) - (parseInt(this.handleSize['width']) / 2) - (this.handleSize.offsetLeft || 0);
				this.moveSeat.y = this.clientSeat.y - parseInt(this.placeStyle['margin-top']) - (parseInt(this.handleSize['height']) / 2) - (this.handleSize.offsetTop || 0);
			},
			
			updateSort: global.throttle(function() {
				var list = this.$parent.$children;
				for (let i = 0; i < list.length; i++) {
					let item = list[i];
					
					if (item != this) {
						let position = getPosition(item.$el),
							minX = position.left - this.boxSeat.x + this.$parent.translate.x,
							maxX = minX + parseInt(getStyle(item.$el, 'width')),
							minY = position.top - this.boxSeat.y + this.$parent.translate.y,
							maxY = minY + parseInt(getStyle(item.$el, 'height'));
						
						if (this.clientSeat.x >= minX && this.clientSeat.x <= maxX && this.clientSeat.y >= minY && this.clientSeat.y <= maxY) {
							this.$parent.sortHandle(this.index, item.index);
							break;
						}
					}
				}
			}, 100, false)
		}
	}
</script>

<style lang="stylus" scoped>
	.draw-item {
		position: initial !important;
		user-select: none;
		
		&:not(.z-dis) >>> > * {
			cursor: move;
		}
		
		.content {
			position: relative;
		
			&.z-move {
				z-index: 999;
				position: absolute;
			}
			
			.handle {
				cursor: move;
			}
		
			.shade {
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
			}
		}
		
		.place {
			box-sizing: border-box;
			border: 1px dashed #ccc;
		}
	}
</style>
